<template>
    <div class="news-promo-mainpage" v-if="indexPage != null && setup != null">
        <div class="container">
            <div class="section-title-new">
                <h2>{{indexPage.news_title_home}}</h2>
                <div class="links-group">
                    <!-- <div class="link-to-insta" v-if="!isMobileChecker">
                        <a :href="setup.sales_setup_new.btn_bazis_insta_home.link" target="_blank">{{ setup.sales_setup_new.btn_bazis_insta_home.desc }}</a>
                    </div> -->
                    <div class="link-to-news" v-if="!isMobileChecker">
                        <router-link to="/news" @click.native="startLoader">
                            <span v-if="lang == ''">Все новости</span>
                            <span v-if="lang == 'kz/'">Барлық жаңалықтар</span>
                            <span v-if="lang == 'en/'">All news</span>
                            <svgIcon name="arrow-go-right"/>
                        </router-link>
                    </div>
                </div>
            </div>
            <newsItems class="news-items-mainpage"></newsItems>
            <div class="link-to-news-mobile" v-if="isMobileChecker">
                <router-link to="/news" @click.native="startLoader">
                    <span v-if="lang == ''">Все новости</span>
                    <span v-if="lang == 'kz/'">Барлық жаңалықтар</span>
                    <span v-if="lang == 'en/'">All news</span>
                    <svgIcon name="arrow-go-right"/>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import newsItems from '@/components/news/news-item.vue'
    import svgIcon from '@/components/partials/SvgIcon.vue';
    export default {
        name: 'news-items-page',
        components: {
            newsItems,
            svgIcon,
        },
        data () {
            return {
                lang: window.GlobalLang,
                routerName: this.$router.history.current.name,
            }
        },
        computed: mapGetters({
           indexPage: 'loadIndexPage',
           setup: 'loadPageSetUp',
           newsItemsDefault: 'loadNewsItemsDefault',
           isMobileChecker: 'loadIsMobileChecker',
        }),
        methods: {
            setFilterNewsLength() {
                setTimeout(() => {
                    if (this.routerName == 'home' || this.routerName == 'about') {
                        this.$store.commit('filterNewsItems', this.newsItemsDefault.slice(0,4));
                    }
                }, 200);
            },
            startLoader() {
                this.$parent.$parent.$refs.topProgress.start();
            },
        },
        beforeCreate() {
            //  this.$store.dispatch('getNewsPageData');
        },
        created () {
        },
        mounted() {
            this.setFilterNewsLength();
            this.$store.watch(
                (state) => state.newsItemsFilter,
                (newValue) => {
                    if (newValue) {
                        this.setFilterNewsLength();
                    }
                }
            )
            this.$store.watch(
                (state) => state.aboutPageArr,
                (newValue) => {
                    if (newValue) {
                        this.setFilterNewsLength();
                    }
                }
            )
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/news/news-items-promo.scss';
    @import '@/styles/respond/news/news-items-promo-respond.scss';
</style>